export const ROUTE_PATHS = {
  HOME: '/products',
  LOGIN: '/login',
  PRODUCTS: '/products',
  PRODUCT_DETAIL: '/products/:id',
  PRODUCT_DETAIL_TAB: '/products/:id/:tab',
  ORGANIZATION: '/organization',
  ACCOUNT: '/account',
  EXPIRED: '/expired',
  REGISTER: '/register',
  REGISTER_THANK_YOU: '/register/thank-you',
  BUILD_ANYTHING: '/build-anything',
  BUILD_ANYTHING_PRINT: '/build-anything/print',
  ONBOARDING_DISCOVERY: '/onboarding/discovery',
  // FROM V1
  NEW_RFQ: '/new-rfq',

  SUPPLIER_APPLICATION: '/supplier-application'
} as const;
